"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OSC_DEVICES_LIMIT = void 0;
exports.OSC_DEVICES_LIMIT = {
    lite: 0,
    plus_v2: 0,
    /** @deprecated */ pro: 0,
    pro_v2: 1,
    /** @deprecated */ premium: Infinity, // there never used to be a device limit
    premium_v2: 3,
    /** @deprecated */ ultimate: Infinity,
    ultimate_v2: Infinity,
};
//# sourceMappingURL=osc.js.map